// extracted by mini-css-extract-plugin
export default {"only-tab-list":"TabOnlyElement_only-tab-list__Zug8M","tab-panel":"TabOnlyElement_tab-panel__BlBuo"};